/**
 * Typography thẻ thống kê KPI — dùng chung Bảng điều khiển, Danh sách án, v.v.
 */
export const DASHBOARD_STAT_LABEL_SX = {
  fontSize: '0.9375rem',
  fontWeight: 700,
  color: 'text.secondary',
  letterSpacing: '0.02em',
  lineHeight: 1.35,
} as const
